// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_OBw","cls2":"ZeroState-cls2_v5u ZeroState-cls1_OBw","left":"ZeroState-left_bfr","right":"ZeroState-right_9ei"};